import create from 'zustand';
import { UpdateCorporateContentQueryState } from './interfaces/UpdateQueryState';
import { createCommonCorporateContentQuerySlice } from './slices/CorporateContentQuerySlices/CommonCorporateContentQuerySlice';
import { createUpdateCorporateContentQuerySlice } from './slices/CorporateContentQuerySlices/UpdateCorporateContentQuerySlice';

export const useUpdateCorporateContentQueryStore = create<UpdateCorporateContentQueryState>(
  (set) => ({
    ...createCommonCorporateContentQuerySlice(set),
    ...createUpdateCorporateContentQuerySlice(set)
  })
);
